import axios from '@/vendor/axios';

export default {
  async getVoucher(code) {
    const response = await axios.get(`v5/vouchers/${code}`);
    return response.data;
  }
};
